var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfficeBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.63,
    height: 20.549,
    viewBox: "0 0 21.63 20.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-work",
    "data-name": "Icon material-work",
    d: "M22.467,7.326H18.141V5.163A2.156,2.156,0,0,0,15.978,3H11.652A2.156,2.156,0,0,0,9.489,5.163V7.326H5.163A2.146,2.146,0,0,0,3.011,9.489L3,21.386a2.156,2.156,0,0,0,2.163,2.163h17.3a2.156,2.156,0,0,0,2.163-2.163V9.489A2.156,2.156,0,0,0,22.467,7.326Zm-6.489,0H11.652V5.163h4.326Z",
    transform: "translate(-3 -3)",
    fill: "#ebfaff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeBag);
export default __webpack_public_path__ + "static/media/office_bag.c9140ccef3f198f0d1c1236e25609ce8.svg";
export { ForwardRef as ReactComponent };